import { render, staticRenderFns } from "./OnboardingScreen.vue?vue&type=template&id=f477db36"
import script from "./OnboardingScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingScreen.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports